<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="shrink-0" :class="$attrs.class">
    <circle cx="8" cy="8" r="4" fill="currentColor" stroke="none" />
    <circle cx="16" cy="8" r="4" fill="currentColor" stroke="none" opacity="0.7" />
    <circle cx="8" cy="16" r="4" fill="currentColor" stroke="none" opacity="0.7" />
    <circle cx="16" cy="16" r="4" fill="currentColor" stroke="none" />
  </svg>
</template>
<script setup>defineOptions({ inheritAttrs: false });</script>
